var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeco1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 796,
    height: 262,
    viewBox: "0 0 796 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.804 13.2615C352.804 13.2622 352.804 13.2628 352.803 13.2631C344.75 16.627 336.778 21.4981 328.855 27.2028C328.397 27.5324 327.969 27.9041 327.572 28.3083C323.549 32.3959 319.464 36.2186 315.281 39.6234V39.6234C315.192 39.7092 315.299 39.8558 315.403 39.7916C322.656 35.3322 329.905 31.5893 337.149 29.006C380.854 13.4259 445.385 36.3698 484.413 4.00112C498.844 -7.9671 506.878 -25.0852 512.497 -43.9684C508.354 -34.6002 502.854 -26.1497 495.256 -19.1703C458.97 14.1587 394.618 -4.20378 352.806 13.2599C352.805 13.2602 352.805 13.2608 352.804 13.2615V13.2615Z",
    fill: "url(#paint0_radial_2957_6093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-32.7888 -147.54C-32.7891 -147.541 -32.7894 -147.541 -32.7895 -147.541C-35.0011 -155.092 -38.6999 -162.354 -43.2316 -169.451C-43.6335 -170.08 -44.1098 -170.655 -44.6376 -171.176C-48.0845 -174.578 -51.2651 -178.077 -54.0319 -181.727V-181.727C-54.1262 -181.826 -54.2844 -181.705 -54.2211 -181.583C-50.7557 -174.883 -48.013 -168.085 -46.4399 -161.126C-36.9568 -119.149 -69.3143 -50.6143 -42.2255 -15.765C-37.2891 -9.41445 -30.8691 -4.81354 -23.4421 -1.42241C-21.2555 -0.424012 -18.7772 -6.29082 -20.3938 -8.10532V-8.10532C-48.8436 -40.0467 -21.1341 -107.746 -32.7882 -147.539C-32.7883 -147.539 -32.7885 -147.54 -32.7888 -147.54V-147.54Z",
    fill: "url(#paint1_radial_2957_6093)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.986 18.3636C114.986 18.3636 114.986 18.3633 114.986 18.3632C108.113 15.5 100.206 13.8586 91.6979 12.8981C91.4335 12.8682 91.1662 12.8654 90.9007 12.8878C85.6284 13.3319 80.4783 13.5281 75.5309 13.338V13.338C75.3235 13.3495 75.299 13.6673 75.5022 13.7104C82.336 15.1613 88.677 17.1238 94.2631 19.8893C133.27 39.2053 156.483 103.319 201.398 105.006C217.711 105.618 234.105 97.8893 250.541 87.0259C241.952 91.2333 233.287 93.8487 224.502 94.0365C180.524 94.9795 154.195 34.6987 114.986 18.3639C114.986 18.3639 114.986 18.3635 114.986 18.3636V18.3636Z",
    fill: "url(#paint2_radial_2957_6093)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16586 5.79109C2.16592 5.79117 2.166 5.79123 2.1661 5.79126C9.58442 8.17987 17.7873 9.51499 26.39 10.2815C23.6544 9.66587 21.0077 8.91497 18.4695 8.00503C18.0101 7.84033 17.5337 7.72922 17.0487 7.68155C11.9884 7.18408 7.00252 6.58168 2.16633 5.79025C2.16587 5.79018 2.16557 5.79072 2.16586 5.79109V5.79109Z",
    fill: "url(#paint3_radial_2957_6093)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250.544 87.0273C250.545 87.0266 250.546 87.026 250.547 87.0255C258.196 83.2789 265.783 78.2697 273.34 72.5826C270.813 74.0618 268.271 75.4002 265.711 76.5723C265.04 76.8796 264.397 77.251 263.8 77.6928C259.38 80.9635 254.96 84.1086 250.544 87.0273V87.0273Z",
    fill: "url(#paint4_radial_2957_6093)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3917 10.2823C26.3913 10.2827 26.3914 10.2834 26.392 10.2835C33.9725 11.9898 42.2437 12.6608 50.8442 12.8005C48.2523 12.4593 45.7287 12.004 43.2848 11.4158C42.591 11.2489 41.8833 11.1458 41.1702 11.1232C36.1638 10.9646 31.2149 10.7127 26.3922 10.2821C26.392 10.2821 26.3919 10.2822 26.3917 10.2823V10.2823Z",
    fill: "url(#paint5_radial_2957_6093)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.339 72.582C280.64 68.3058 287.813 62.8462 294.921 56.7813C292.552 58.4219 290.161 59.9322 287.743 61.2915C287.18 61.6078 286.643 61.9714 286.144 62.3864C281.882 65.9306 277.616 69.3642 273.339 72.582Z",
    fill: "url(#paint6_radial_2957_6093)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.01 11.2177C155.009 11.218 155.009 11.2182 155.008 11.218C145.005 8.48345 133.191 8.39154 120.664 9.23858C115.922 10.1106 111.236 10.8447 106.657 11.335C117.117 11.5342 126.891 12.5768 135.268 15.4496C174.471 28.8951 203.6 85.2654 246.473 81.8522C252.58 81.3663 258.557 79.6967 264.436 77.1397C264.609 77.0644 264.773 76.9687 264.926 76.8552C266.439 75.7289 267.952 74.5889 269.466 73.4393C271.174 72.1417 269.323 68.2788 267.225 68.5673V68.5673C225.61 74.2835 194.003 21.8798 155.011 11.2174C155.011 11.2172 155.01 11.2174 155.01 11.2177V11.2177Z",
    fill: "url(#paint7_radial_2957_6093)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M380.041 -19.6909C380.041 -19.6909 380.041 -19.6905 380.041 -19.6903C369.391 -13.8676 359.264 -5.09844 349.325 4.6958C346.149 8.55011 342.933 12.271 339.649 15.7641C348.643 8.13867 357.754 1.49367 367.111 -3.00798C406.93 -22.1591 470.791 -8.19869 504.314 -42.2643C509.441 -47.4751 513.431 -53.3753 516.579 -59.7769C516.663 -59.9493 516.728 -60.1314 516.772 -60.3191C516.946 -61.0669 517.118 -61.8158 517.289 -62.5656C517.862 -65.0806 513.298 -67.0635 511.602 -65.1562V-65.1562C480.848 -30.5752 417.783 -40.3259 380.04 -19.6914C380.04 -19.6913 380.04 -19.6909 380.041 -19.6909V-19.6909Z",
    fill: "url(#paint8_radial_2957_6093)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.42532 -124.7C-3.42538 -124.7 -3.42584 -124.7 -3.42598 -124.7C-7.78126 -134.639 -15.1838 -143.63 -23.6476 -152.283V-152.283C-24.58 -153.006 -26.5183 -151.08 -25.8729 -150.078C-22.8133 -145.329 -20.2517 -140.453 -18.4128 -135.395C-4.77191 -97.8586 -27.9697 -31.2839 1.61771 -2.24367C6.1259 2.18075 11.4852 5.36687 17.4668 7.63443C17.6751 7.71341 17.893 7.76335 18.1144 7.78444C19.3131 7.89866 20.5157 8.00729 21.7212 8.11143C24.1442 8.32074 25.5388 3.45981 23.6747 1.86044V1.86044C-6.82776 -24.3062 12.0091 -89.476 -3.42467 -124.7C-3.42481 -124.701 -3.42526 -124.701 -3.42532 -124.7V-124.7Z",
    fill: "url(#paint9_radial_2957_6093)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.622 44.6132C308.175 44.918 307.748 45.2546 307.35 45.6254C303.22 49.4739 299.082 53.2317 294.921 56.7816C301.427 52.2792 307.766 46.8053 314.022 40.8346C314.091 40.7687 314.011 40.6584 313.931 40.7091V40.7091C312.179 42.0898 310.411 43.3944 308.622 44.6132Z",
    fill: "url(#paint10_radial_2957_6093)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9043 12.694C67.3238 12.6155 66.7379 12.5814 66.1521 12.6018C60.9856 12.7818 55.8598 12.8794 50.8447 12.7988C57.8147 13.7141 65.2731 13.8082 72.9706 13.4655C73.1265 13.4585 73.1439 13.2312 72.9906 13.2023V13.2023C71.2675 13.0863 69.5705 12.9194 67.9043 12.694Z",
    fill: "url(#paint11_radial_2957_6093)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.773 64.7344C280.774 64.7337 280.775 64.7331 280.776 64.7326C282.774 63.8836 284.754 62.9203 286.715 61.8563C286.834 61.7921 286.945 61.716 287.049 61.6292C292.213 57.3172 297.371 52.8537 302.532 48.4301C302.557 48.4089 302.531 48.3695 302.503 48.3852V48.3852C295.259 53.5316 288.015 59.1272 280.773 64.7344V64.7344Z",
    fill: "url(#paint12_radial_2957_6093)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4258 9.66274C41.3735 9.58489 41.123 10.8637 42.1446 11.1301V11.1301C42.2089 11.1468 42.2762 11.1565 42.3426 11.1585C48.5277 11.337 54.7921 11.384 61.0064 11.4606C61.0536 11.4611 61.0631 11.3876 61.0174 11.3757V11.3757C54.9866 10.6487 48.7428 10.1301 42.4258 9.66274Z",
    fill: "url(#paint13_radial_2957_6093)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M327.963 26.7907C327.858 26.8997 327.753 27.0087 327.649 27.1177C327.34 27.4392 327.785 27.9775 328.144 27.7171V27.7171C328.16 27.7052 328.175 27.692 328.189 27.6774C330.293 25.5236 332.378 23.3003 334.454 21.0257C332.326 23.0674 330.165 24.9964 327.964 26.7896L327.963 26.7907Z",
    fill: "url(#paint14_radial_2957_6093)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1652 12.4512C87.1653 12.4511 87.1654 12.4511 87.1656 12.4511C88.2888 12.5464 89.403 12.6518 90.5074 12.7677C91.0362 12.8232 91.5693 12.8306 92.0995 12.7823C94.8977 12.5274 97.7298 12.2065 100.58 11.8398C97.7807 11.9975 95.031 12.0444 92.3465 11.9505C90.6176 12.1244 88.8908 12.2927 87.1656 12.452C87.1651 12.4521 87.1649 12.4515 87.1652 12.4512V12.4512Z",
    fill: "url(#paint15_radial_2957_6093)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3354 11.986C80.3356 11.9858 80.3355 11.9854 80.3352 11.9854C77.9096 12.0998 75.4783 12.2159 73.0487 12.3242C72.5679 12.3456 72.5156 13.1115 72.9879 13.2021V13.2021C73.8283 13.2586 74.6764 13.303 75.5296 13.3373C77.5355 13.2246 79.5555 13.086 81.5852 12.9279C82.171 12.8822 82.1711 12.0903 81.5851 12.0562C81.1695 12.032 80.753 12.0088 80.3356 11.9865C80.3353 11.9865 80.3352 11.9862 80.3354 11.986V11.986Z",
    fill: "url(#paint16_radial_2957_6093)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M318.408 35.1745C316.73 36.7686 315.053 38.3651 313.375 39.9557C312.99 40.3205 313.483 40.9904 313.929 40.7102V40.7102C314.382 40.3541 314.832 39.9921 315.281 39.6256C316.537 38.4123 317.79 37.18 319.04 35.9328C319.544 35.4299 318.961 34.7323 318.407 35.1756V35.1756L318.408 35.1745Z",
    fill: "url(#paint17_radial_2957_6093)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M302.988 48.0411C302.988 48.0418 302.987 48.0424 302.987 48.0428C302.984 48.0451 302.981 48.0474 302.979 48.0498C302.95 48.0744 302.98 48.1202 303.012 48.1017C304.671 47.1692 306.312 46.1573 307.935 45.0735C307.944 45.0677 307.952 45.0611 307.96 45.0539V45.0539C308.135 44.8907 307.933 44.6191 307.736 44.7524C306.153 45.8234 304.571 46.9206 302.989 48.0391C302.988 48.0396 302.988 48.0403 302.988 48.0411V48.0411Z",
    fill: "url(#paint18_radial_2957_6093)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7832 11.4687C61.7828 11.4691 61.7823 11.4692 61.7818 11.4692C61.7769 11.4692 61.7719 11.4691 61.767 11.469C61.7153 11.4684 61.7054 11.5467 61.7557 11.5588C63.4686 11.9694 65.2237 12.3023 67.0138 12.5681C67.025 12.5698 67.0363 12.5704 67.0476 12.57V12.57C67.2793 12.5618 67.3002 12.2273 67.071 12.1926C65.3303 11.9294 63.567 11.6895 61.7848 11.4683C61.7842 11.4682 61.7837 11.4684 61.7832 11.4687V11.4687Z",
    fill: "url(#paint19_radial_2957_6093)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M304.794 39.1805C304.794 39.1808 304.794 39.1812 304.793 39.1813C266.108 48.9734 230.508 4.5658 192.506 -0.89216C178.786 -2.86321 162.253 0.344122 145.273 4.05115C141.551 5.01034 137.85 5.8998 134.191 6.66797C148.675 4.55765 162.506 3.33745 174.117 5.74242C212.705 13.7387 246.472 62.1459 286.685 54.3022C292.171 53.2329 297.425 51.1823 302.503 48.3834C302.664 48.2689 302.824 48.1554 302.986 48.0409C308.119 43.6446 313.256 39.2917 318.407 35.1702C320.337 33.3361 322.269 31.5043 324.202 29.6873C318.113 34.1068 311.695 37.432 304.794 39.1797C304.794 39.1798 304.793 39.1802 304.794 39.1805V39.1805Z",
    fill: "url(#paint20_radial_2957_6093)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M520.996 -109.838C520.996 -109.838 520.995 -109.838 520.995 -109.838C495.732 -74.8657 435.089 -76.8483 401.697 -53.8488C388.584 -44.8173 377.053 -30.6846 365.683 -16.0784C363.371 -12.8776 361.038 -9.73787 358.664 -6.7089C369.178 -18.5625 379.922 -29.4985 391.577 -36.6748C427.171 -58.593 489.158 -52.8399 517.154 -87.7216C521.246 -92.819 524.283 -98.3792 526.533 -104.278C526.599 -104.542 526.669 -104.806 526.737 -105.068C527.714 -111.435 528.72 -117.75 529.905 -123.903C530.144 -126.428 530.386 -128.949 530.639 -131.456C528.814 -123.756 525.791 -116.475 520.997 -109.838C520.997 -109.838 520.996 -109.838 520.996 -109.838V-109.838Z",
    fill: "url(#paint21_radial_2957_6093)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4144 4.98611C67.4151 4.98558 67.415 4.98454 67.4143 4.98409C35.7348 -15.5754 46.3879 -77.1854 27.9473 -107.672C20.706 -119.645 8.09208 -129.29 -5.0226 -138.704C-7.92221 -140.585 -10.7571 -142.497 -13.4744 -144.466C-3.01492 -135.524 6.48604 -126.219 12.0636 -115.457C29.0991 -82.5878 14.4495 -19.0788 45.6476 4.25669C50.2068 7.66762 55.3834 9.94594 61.0144 11.379C61.2709 11.4092 61.527 11.4415 61.7822 11.4727C68.0664 11.5527 74.2949 11.6694 80.334 11.9893C82.8469 11.8709 85.3559 11.7558 87.8491 11.6537C80.3412 10.9067 73.4271 8.8887 67.4145 4.98812C67.4138 4.98767 67.4138 4.98664 67.4144 4.98611V4.98611Z",
    fill: "url(#paint22_radial_2957_6093)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.579 11.8398C102.581 11.7273 104.607 11.5554 106.657 11.3354C106.183 11.326 105.707 11.3185 105.229 11.3131C104.76 11.3077 104.29 11.3397 103.824 11.4045C102.74 11.5552 101.657 11.7005 100.579 11.8398Z",
    fill: "url(#paint23_radial_2957_6093)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M334.454 21.0266C334.455 21.027 334.455 21.027 334.455 21.0267C336.209 19.3431 337.939 17.5847 339.65 15.7642C338.984 16.3285 338.32 16.8985 337.655 17.473C336.59 18.6683 335.524 19.8533 334.454 21.0256C334.454 21.0259 334.454 21.0263 334.454 21.0266V21.0266Z",
    fill: "url(#paint24_radial_2957_6093)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.441 9.63965C117.193 9.49154 118.936 9.35672 120.664 9.23958C122.679 8.86928 124.703 8.47203 126.733 8.06022C124.241 8.46037 121.778 8.77973 119.354 9.0061C118.051 9.21757 116.748 9.43016 115.446 9.63938C115.444 9.63961 115.443 9.6397 115.441 9.63965V9.63965Z",
    fill: "url(#paint25_radial_2957_6093)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M345.259 8.76384C345.259 8.76354 345.259 8.76312 345.259 8.76285C346.612 7.39068 347.966 6.03225 349.326 4.69447C350.508 3.26114 351.685 1.80714 352.858 0.342757C351.127 2.33338 349.369 4.24791 347.576 6.07238C346.805 6.97032 346.033 7.86827 345.26 8.76386C345.26 8.76421 345.259 8.7642 345.259 8.76384V8.76384Z",
    fill: "url(#paint26_radial_2957_6093)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M337.653 17.4719C340.199 14.6132 342.73 11.6971 345.258 8.76375C340.997 13.0881 336.761 17.5533 332.526 22.0061C334.232 20.4673 335.941 18.9536 337.653 17.4719Z",
    fill: "url(#paint27_radial_2957_6093)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.814 11.3013C104.286 11.3037 104.759 11.273 105.228 11.206C108.619 10.7209 112.03 10.1872 115.441 9.63858C109.803 10.1152 104.056 10.7299 98.2939 11.335C100.15 11.305 101.991 11.2922 103.814 11.3013Z",
    fill: "url(#paint28_radial_2957_6093)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M327.964 26.791C329.485 25.2032 331.006 23.605 332.526 22.0069C329.744 24.5144 326.972 27.0871 324.204 29.6894C325.472 28.769 326.725 27.8013 327.964 26.791Z",
    fill: "url(#paint29_radial_2957_6093)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3449 11.9488C94.3271 11.7501 96.311 11.5425 98.2948 11.3349C94.8575 11.3913 91.3684 11.506 87.8506 11.6504C89.3262 11.7968 90.8258 11.8963 92.3449 11.9488Z",
    fill: "url(#paint30_radial_2957_6093)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M126.733 8.05849C126.733 8.05867 126.733 8.05877 126.734 8.05873C129.194 7.6642 131.682 7.19567 134.192 6.66764C133.273 6.80151 132.35 6.93867 131.426 7.07915C129.859 7.41274 128.295 7.74071 126.733 8.0574C126.733 8.0575 126.733 8.05809 126.733 8.05849V8.05849Z",
    fill: "url(#paint31_radial_2957_6093)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M352.859 0.34113C352.858 0.340847 352.858 0.34044 352.859 0.340168C354.827 -1.92238 356.757 -4.2807 358.663 -6.70937C357.929 -5.88035 357.194 -5.04793 356.463 -4.21197C355.264 -2.68395 354.065 -1.16504 352.86 0.341134C352.859 0.341499 352.859 0.341497 352.859 0.34113V0.34113Z",
    fill: "url(#paint32_radial_2957_6093)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M527.644 -252.19C527.644 -252.19 527.645 -252.19 527.645 -252.19C536.047 -290.291 582.131 -333.594 575.757 -369.406C574.086 -378.797 569.012 -386.516 562.068 -393.319C559.018 -395.819 555.961 -398.317 552.962 -400.839C549.437 -403.394 545.852 -405.923 542.305 -408.471C524.345 -420.118 503.869 -430.554 493.172 -445.848C473.524 -473.942 480.388 -533.441 448.433 -551.293C439.621 -556.215 429.182 -557.231 417.929 -556.181C413.885 -555.523 409.851 -554.863 405.857 -554.257C401.24 -553.272 396.609 -552.232 392.01 -551.227C369.332 -545.389 345.897 -537.036 327.191 -538.573C289.947 -541.633 252.832 -582.059 215.789 -570.503C206.076 -567.473 197.564 -561.24 189.709 -553.248C186.752 -549.806 183.795 -546.358 180.823 -542.966C177.741 -539.036 174.678 -535.05 171.601 -531.099C157.287 -511.274 143.836 -489.077 126.879 -476.077C95.7289 -452.199 36.6764 -450.65 14.1056 -415.786C7.88223 -406.173 5.36718 -395.471 4.82058 -384.241C4.90753 -380.245 4.99741 -376.259 5.03954 -372.306C5.3743 -367.778 5.76292 -363.243 6.12038 -358.735C8.77685 -336.635 13.8593 -314.126 9.63923 -294.989C1.23751 -256.888 -44.8472 -213.584 -38.473 -177.772C-36.8019 -168.381 -31.7278 -160.663 -24.7846 -153.86C-21.7342 -151.36 -18.6767 -148.862 -15.6783 -146.34C-12.1532 -143.785 -8.5686 -141.255 -5.021 -138.707C12.9393 -127.06 33.4153 -116.624 44.1118 -101.331C63.7598 -73.236 56.8962 -13.7371 88.8513 4.11414C97.6626 9.03611 108.102 10.0525 119.354 9.00281C123.399 8.34467 127.433 7.68504 131.427 7.07846C136.044 6.09371 140.674 5.05371 145.274 4.04896C167.951 -1.79104 191.387 -10.1428 210.093 -8.60564C247.337 -5.5457 284.452 34.8809 321.495 23.3246C331.208 20.2946 339.72 14.0618 347.575 6.06938C350.532 2.62776 353.489 -0.820703 356.461 -4.21285C359.543 -8.1424 362.606 -12.1284 365.683 -16.0797C379.997 -35.9049 393.448 -58.1014 410.405 -71.101C441.555 -94.98 500.608 -96.5288 523.178 -131.392C529.402 -141.005 531.917 -151.708 532.463 -162.938C532.376 -166.934 532.286 -170.92 532.244 -174.872C531.91 -179.401 531.521 -183.935 531.164 -188.443C528.507 -210.543 523.425 -233.052 527.644 -252.19C527.644 -252.19 527.644 -252.19 527.644 -252.19V-252.19ZM523.753 -152.273C503.816 -117.712 446.584 -112.884 417.699 -88.3207C387.755 -62.8574 372.043 -6.26832 336.741 6.86402C301.439 19.9964 263.126 -16.4914 226.802 -17.3008C191.763 -18.0825 141.865 16.9473 109.839 1.71668C77.8119 -13.514 81.1077 -70.7033 60.4458 -96.4099C39.0272 -123.059 -15.8268 -130.874 -24.0396 -164.701C-32.2523 -198.528 10.0293 -242.481 16.029 -279.331C21.8174 -314.878 -6.40625 -360.341 13.5307 -394.903C33.4677 -429.465 90.6991 -434.292 119.584 -458.855C149.529 -484.319 165.241 -540.908 200.542 -554.04C235.844 -567.173 274.158 -530.685 310.481 -529.875C345.521 -529.094 395.418 -564.124 427.445 -548.893C459.472 -533.662 456.176 -476.473 476.838 -450.766C498.256 -424.117 553.11 -416.302 561.323 -382.475C569.536 -348.648 527.254 -304.695 521.254 -267.845C515.466 -232.299 543.69 -186.835 523.753 -152.273Z",
    fill: "url(#paint33_radial_2957_6093)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M546.191 -393.967C546.191 -393.967 546.191 -393.967 546.191 -393.968C536.318 -425.75 482.706 -430.095 460.439 -454.287C438.96 -477.625 438.923 -532.332 407.019 -545.037C375.113 -557.744 328.726 -521.524 294.716 -520.284C259.461 -519 220.262 -551.616 186.785 -537.097C153.308 -522.578 141.275 -467.739 113.688 -441.768C87.0761 -416.716 31.8737 -408.873 14.5023 -374.795C-2.87052 -340.716 27.0544 -298.972 23.4524 -264.755C19.7174 -229.284 -18.7839 -184.988 -8.91144 -153.204C0.961059 -121.421 54.574 -117.077 76.8408 -92.8842C98.3205 -69.5461 98.357 -14.839 130.261 -2.13379C162.167 10.5726 208.554 -25.647 242.563 -26.8879C277.818 -28.1719 317.018 4.44387 350.495 -10.0754C383.971 -24.5947 396.005 -79.4335 423.591 -105.404C450.203 -130.457 505.406 -138.3 522.777 -172.378C540.15 -206.457 510.225 -248.2 513.826 -282.416C517.561 -317.886 556.061 -362.182 546.19 -393.966C546.19 -393.966 546.19 -393.967 546.191 -393.967V-393.967ZM520.326 -191.611C505.435 -158.189 452.446 -147.603 428.104 -122.249C402.868 -95.9676 394.315 -43.0844 362.731 -27.3702C331.148 -11.6559 291.369 -40.4894 257.318 -37.273C224.471 -34.1706 181.616 2.93123 150.019 -7.35989C118.422 -17.651 115.301 -69.7267 93.1948 -90.7278C70.2787 -112.499 18.1423 -113.603 6.79388 -143.301C-4.55452 -172.998 30.2134 -217.342 31.8269 -251.319C33.3836 -284.094 2.06449 -322.139 16.9564 -355.562C31.8482 -388.984 84.8357 -399.571 109.179 -424.924C134.415 -451.206 142.968 -504.089 174.551 -519.803C206.135 -535.517 245.914 -506.684 279.965 -509.9C312.812 -513.003 355.667 -550.104 387.264 -539.813C418.861 -529.522 421.98 -477.445 444.088 -456.445C467.004 -434.674 519.141 -433.571 530.489 -403.873C541.837 -374.175 507.069 -329.831 505.456 -295.855C503.899 -263.079 535.218 -225.034 520.326 -191.611Z",
    fill: "url(#paint34_radial_2957_6093)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M514.335 -412.194C501.696 -439.779 451.252 -437.885 427.881 -457.282C405.336 -475.994 399.389 -525.311 368.275 -533.309C337.161 -541.307 297.839 -503.625 266.272 -498.823C233.549 -493.844 193.484 -519.002 163.849 -502.283C134.213 -485.565 128.926 -434.822 106.021 -408.419C83.9243 -382.949 33.3166 -369.897 20.8075 -337.291C8.2984 -304.684 40.7064 -270.294 41.0474 -239.056C41.4021 -206.673 10.3013 -162.565 22.9416 -134.981C35.5805 -107.396 86.0237 -109.29 109.395 -89.8928C131.94 -71.181 137.888 -21.8637 169.001 -13.8658C200.115 -5.86801 239.437 -43.5495 271.004 -48.3517C303.727 -53.3311 343.793 -28.1726 373.427 -44.8917C403.063 -61.6096 408.35 -112.353 431.256 -138.756C453.352 -164.226 503.96 -177.278 516.469 -209.884C528.978 -242.491 496.57 -276.881 496.229 -308.119C495.874 -340.502 526.975 -384.61 514.335 -412.194ZM511.291 -227.115C501.057 -195.474 452.973 -180.239 433.088 -154.828C412.476 -128.487 410.228 -80.0457 382.582 -62.5149C354.934 -44.9829 314.87 -66.5944 283.584 -60.0264C253.404 -53.6911 217.589 -15.7255 187.126 -21.5592C156.663 -27.3928 148.152 -73.8476 125.351 -90.3314C101.714 -107.418 53.1604 -102.78 39.4173 -128.237C25.6733 -153.695 53.1952 -197.296 51.0326 -227.998C48.947 -257.616 15.7518 -288.418 25.9844 -320.058C36.2184 -351.698 84.3024 -366.933 104.187 -392.344C124.799 -418.686 127.048 -467.127 154.694 -484.658C182.342 -502.189 222.406 -480.578 253.692 -487.146C283.872 -493.481 319.687 -531.447 350.15 -525.613C380.614 -519.778 389.124 -473.325 411.925 -456.841C435.561 -439.755 484.115 -444.393 497.858 -418.936C511.602 -393.477 484.081 -349.877 486.243 -319.174C488.329 -289.557 521.524 -258.754 511.291 -227.115Z",
    fill: "url(#paint35_radial_2957_6093)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M481.187 -424.12C466.525 -447.455 420.038 -440.331 396.321 -455.183C373.443 -469.508 362.643 -513.022 332.983 -516.833C303.324 -520.645 270.972 -482.678 242.268 -474.981C212.513 -467.002 172.725 -485.213 147.089 -467.056C121.453 -448.9 122.007 -402.903 103.638 -376.799C85.9201 -351.618 40.4757 -334.487 32.3978 -303.948C24.3199 -273.41 58.0107 -246.11 61.6806 -218.18C65.4854 -189.227 41.4337 -146.39 56.0952 -123.056C70.7568 -99.7208 117.245 -106.844 140.961 -91.9927C163.839 -77.6674 174.641 -34.1549 204.299 -30.3422C233.958 -26.5306 266.31 -64.4977 295.014 -72.1943C324.769 -80.1735 364.558 -61.9623 390.193 -80.1192C415.829 -98.2761 415.275 -144.273 433.644 -170.377C451.362 -195.557 496.806 -212.69 504.884 -243.227C512.962 -273.766 479.272 -301.066 475.602 -328.996C471.797 -357.949 495.849 -400.785 481.187 -424.12ZM464.396 -337.565C469.487 -311.377 503.386 -287.468 497.336 -258.156C491.285 -228.843 448.58 -210.103 432.963 -185.312C416.776 -159.613 419.884 -116.176 396.268 -97.5781C372.652 -78.9802 333.403 -93.9576 305.259 -84.7463C278.11 -75.8605 249.15 -38.1665 220.439 -40.1031C191.727 -42.0396 178.913 -82.5529 156.128 -94.8089C132.508 -107.513 88.2389 -98.1705 72.8442 -119.4C57.4495 -140.629 78.1616 -182.459 72.8835 -209.606C67.7921 -235.794 33.8929 -259.703 39.9436 -289.016C45.9944 -318.328 88.699 -337.068 104.316 -361.859C120.504 -387.559 117.395 -430.995 141.011 -449.593C164.627 -468.191 203.877 -453.214 232.02 -462.425C259.169 -471.311 288.129 -509.005 316.841 -507.068C345.552 -505.132 358.367 -464.618 381.151 -452.362C404.771 -439.659 449.04 -449.001 464.435 -427.771C479.83 -406.542 459.118 -364.712 464.396 -337.565Z",
    fill: "url(#paint36_radial_2957_6093)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M366.514 -448.45C343.987 -458.728 329.437 -496.209 301.805 -496.427C274.173 -496.645 248.516 -459.483 222.984 -449.585C196.517 -439.325 158.053 -451.248 136.454 -432.391C114.854 -413.534 120.259 -372.752 106.178 -347.616C92.5928 -323.368 52.7002 -303.306 48.5373 -275.33C44.3743 -247.354 78.2088 -226.71 84.5519 -202.302C91.1278 -177 73.6095 -136.4 89.553 -117.247C105.496 -98.0936 147.415 -109.379 170.767 -98.7253C193.294 -88.4471 207.844 -50.9663 235.476 -50.7481C263.109 -50.53 288.765 -87.6927 314.297 -97.5902C340.764 -107.851 379.228 -95.9277 400.828 -114.784C422.427 -133.641 417.022 -174.423 431.104 -199.56C444.688 -223.808 484.581 -243.87 488.744 -271.846C492.907 -299.821 459.072 -320.465 452.729 -344.873C446.153 -370.175 463.672 -410.775 447.728 -429.928C431.785 -449.082 389.866 -437.796 366.514 -448.45ZM440.708 -350.916C448.134 -328.316 481.64 -310.79 479.218 -284.245C476.795 -257.701 439.765 -236.605 428.126 -213.039C416.06 -188.611 423.503 -150.557 403.898 -131.616C384.294 -112.674 346.848 -121.738 322.111 -110.61C298.249 -99.875 275.785 -63.4889 249.349 -62.1514C222.912 -60.814 206.911 -95.2517 184.795 -103.66C161.869 -112.377 122.413 -99.4198 106.099 -116.543C89.7847 -133.666 104.274 -172.829 96.5754 -196.257C89.1493 -218.857 55.6427 -236.383 58.0655 -262.928C60.4882 -289.472 97.5176 -310.568 109.157 -334.134C121.223 -358.562 113.78 -396.616 133.384 -415.558C152.989 -434.499 190.435 -425.435 215.172 -436.563C239.034 -447.298 261.498 -483.684 287.934 -485.022C314.371 -486.359 330.372 -451.921 352.488 -443.513C375.413 -434.796 414.87 -447.753 431.184 -430.63C447.498 -413.507 433.009 -374.344 440.708 -350.916Z",
    fill: "url(#paint37_radial_2957_6093)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M339.155 -437.633C317.598 -444.287 300.425 -475.695 275.289 -472.968C250.154 -470.24 230.753 -434.863 208.594 -423.465C185.623 -411.65 149.409 -418.066 131.766 -399.207C114.123 -380.35 123.336 -345.075 113.188 -321.489C103.398 -298.739 69.2586 -276.89 68.4239 -251.86C67.5892 -226.829 100.515 -212.258 108.853 -191.474C117.496 -169.93 105.856 -132.391 122.366 -117.24C138.874 -102.088 175.78 -116.439 198.129 -109.541C219.686 -102.887 236.859 -71.4791 261.994 -74.2066C287.13 -76.9341 306.53 -112.311 328.69 -123.71C351.661 -135.524 387.875 -129.109 405.517 -147.967C423.161 -166.824 413.947 -202.099 424.096 -225.685C433.885 -248.435 468.025 -270.284 468.86 -295.314C469.694 -320.345 436.769 -334.916 428.43 -355.7C419.787 -377.245 431.428 -414.783 414.918 -429.934C398.408 -445.085 361.504 -430.736 339.155 -437.633ZM415.998 -359.236C425.076 -340.266 457.186 -328.471 457.78 -305.021C458.374 -281.57 427.127 -259.245 419.081 -237.431C410.74 -214.816 421.453 -182.346 405.724 -163.733C389.996 -145.121 355.212 -149.108 334.03 -136.786C313.595 -124.898 297.113 -90.7426 273.367 -86.7958C249.622 -82.849 231.556 -111.263 210.694 -116.287C189.067 -121.496 154.777 -106.029 138.242 -119.28C121.708 -132.53 130.693 -168.275 121.283 -187.939C112.205 -206.908 80.0957 -218.703 79.5017 -242.154C78.9078 -265.604 110.155 -287.929 118.2 -309.744C126.541 -332.358 115.829 -364.828 131.558 -383.441C147.286 -402.053 182.069 -398.066 203.251 -410.389C223.686 -422.276 240.169 -456.432 263.914 -460.379C287.659 -464.325 305.725 -435.911 326.587 -430.887C348.214 -425.679 382.504 -441.146 399.039 -427.895C415.574 -414.645 406.588 -378.899 415.998 -359.236Z",
    fill: "url(#paint38_radial_2957_6093)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(461.39 -57.9398) rotate(-53.3899) scale(392.767 106.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-38.637 -140.395) rotate(-89.1327) scale(272.29 153.407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.899 -6.14396) rotate(-87.1385) scale(262.595 149.591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5723 0.439905) rotate(-75.0234) scale(37.3749 20.4216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.565 73.1279) rotate(-44.2483) scale(49.1809 4.62183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5083 3.9251) rotate(-70.9846) scale(38.5888 19.9033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.02 58.4182) rotate(-41.8735) scale(48.7656 2.21516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.909 -17.0934) rotate(-81.2554) scale(262.169 149.828)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.074 -83.742) rotate(-50.9056) scale(375.548 84.4639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-13.9872 -123.244) rotate(-94.6489) scale(244.292 129.845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.376 42.5746) rotate(-41.2803) scale(46.7078 1.55137)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.7686 5.91621) rotate(-67.4125) scale(37.5676 18.0262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.918 50.1791) rotate(-41.7866) scale(50.0656 2.1847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.813 2.4965) rotate(-70.3391) scale(39.9377 20.3636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332.992 22.5806) rotate(-42.5951) scale(25.1918 1.51751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.4866 8.01737) rotate(-64.211) scale(22.2706 9.82183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.0391 6.86451) rotate(-66.1071) scale(29.6756 13.7912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(322.129 32.5246) rotate(-42.2957) scale(35.6916 1.93086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(308.34 43.8688) rotate(-43.4131) scale(15.3532 1.18175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.7015 9.59611) rotate(-72.5406) scale(11.9324 6.31067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.971 -40.9854) rotate(-71.9664) scale(298.614 156.541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(498.679 -119.711) rotate(-47.9036) scale(392.351 65.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5999 -111.387) rotate(-102.277) scale(237.941 108.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.415 9.72291) rotate(-62.6189) scale(10.2355 4.29433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(338.894 16.6158) rotate(-43.2619) scale(13.3999 0.990054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.754 5.40187) rotate(-60.2828) scale(19.4557 7.50246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.779 1.735) rotate(-44.8974) scale(20.4733 2.1932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(343.417 10.9205) rotate(-43.7409) scale(33.2516 2.78173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.195 5.23319) rotate(-61.9535) scale(29.0575 11.9186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.309 23.2509) rotate(-42.1207) scale(20.5898 1.03985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.2829 8.27454) rotate(-64.8821) scale(17.2375 7.75084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.664 5.09356) rotate(-58.4537) scale(13.1052 4.6807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(357.863 -5.52066) rotate(-46.5641) scale(16.4001 2.3055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(347.843 -528.518) rotate(-67.9185) scale(1325.8 643.557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(342.776 -512.212) rotate(-67.9185) scale(1241.01 602.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(338.924 -499.818) rotate(-67.9185) scale(1176.55 571.111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.026 -484.043) rotate(-67.9185) scale(1094.51 531.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.256 -465.474) rotate(-67.9185) scale(997.936 484.409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2957_6093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(321.824 -444.766) rotate(-67.9185) scale(890.243 432.134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco1);
export default __webpack_public_path__ + "static/media/deco1.bba29cbeea12b6cefe4d80a16bbde334.svg";
export { ForwardRef as ReactComponent };